import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaFunctionNode } from './TypedNode'
import { SchemaFunctionModel } from './ViewModel'

export const SchemaFunctionPlugin = createSchemaPlugin(
  'Schema.Function',
  SchemaFunctionModel,
  SchemaFunctionNode
)
